export const formatCurrency = (value?: number | string, hideDecimals = false) => {
  if (value === undefined || value === null) {
    return '-';
  }

  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    ...(hideDecimals && { minimumFractionDigits: 0, maximumFractionDigits: 0 })
  }).format(Number(value));
};
